export enum YandexDocumentSelectField {
    ya_name = "ya_name",
    ya_full_name = "ya_full_name",
    ya_bank_name = "ya_bank_name",
    ya_bic ="ya_bic",
    ya_corr_account = "ya_corr_account",
    ya_payment_account = "ya_payment_account"
}
